import gql from 'graphql-tag';

import ContentItemsFragment from './ContentItems.js';
import GalleryItemFragment from './GalleryItem';
import ImageItemFragment from './ImageItem';
import UnknownItemFragment from './UnknownItem.gql';
import VideoItemFragment from './VideoItem.gql';

export default gql`
  fragment StandaloneContentBundleFragment on StandaloneContentBundle {
    id
    layout
    data {
      resourceId
      title
      publishedAt
      modifiedAt
      updatedAt
      canonical
      categories {
        name
        slug
      }
      tags {
        name
        slug
      }
      author {
        name
        authorUrl
        imageUrl
        jobTitle
        bio
        twitterUrl
        pinterestUrl
        instagramUrl
        personalUrl
      }
      status

      coverMedia {
        ...GalleryItemFragment
        ...ImageItemFragment
        ...UnknownItemFragment
        ...VideoItemFragment
      }
      ads {
        targeting {
          tags
          categories
          recipe
        }
        enabled
      }
      sponsor {
        name
        messaging
      }
      pinterestBoardImage
      pinterestPostTitle
    }
    above {
      ...ContentItemsFragment
    }
    items {
      ...ContentItemsFragment
    }
    below {
      ...ContentItemsFragment
    }
    aside {
      ...ContentItemsFragment
    }
  }
  ${ContentItemsFragment}
  ${GalleryItemFragment}
  ${ImageItemFragment}
  ${UnknownItemFragment}
  ${VideoItemFragment}
`;
